import * as THREE from 'three';

export type RepositionDirection =
    'right' | 'left' | 'back' | 'front' | 'up' | 'down';

/**
 * Movement vector for the Position Editor reposition buttons (mm → scene units).
 * @param {RepositionDirection} direction - The direction to move.
 * @param {number} amount - The amount to move.
 * @param {boolean} isAppliedPanel - Whether the cabinet is an applied panel.
 * @param {boolean} isUpperProduct - Whether the cabinet is an upper product.
 * @return {THREE.Vector3} The movement vector.
 */
export const calculateMovementVector = (
    direction: RepositionDirection,
    amount: number,
    isAppliedPanel?: boolean,
    isUpperProduct?: boolean
): THREE.Vector3 => {
    const movementVector = new THREE.Vector3();
    const adjustedStep = amount * 0.2;

    if (isAppliedPanel && isUpperProduct) {
        switch (direction) {
            case 'up':
                movementVector.set(0, adjustedStep, 0);
                break;
            case 'down':
                movementVector.set(0, -adjustedStep, 0);
                break;
            case 'left':
                movementVector.set(-adjustedStep, 0, 0);
                break;
            case 'right':
                movementVector.set(adjustedStep, 0, 0);
                break;
            case 'front':
                movementVector.set(0, 0, adjustedStep);
                break;
            case 'back':
                movementVector.set(0, 0, -adjustedStep);
                break;
        }
        return movementVector;
    }

    switch (direction) {
        case 'left':
            movementVector.set(-adjustedStep, 0, 0);
            break;
        case 'right':
            movementVector.set(adjustedStep, 0, 0);
            break;
        case 'back':
            movementVector.set(0, 0, -adjustedStep);
            break;
        case 'front':
            movementVector.set(0, 0, adjustedStep);
            break;
        case 'up':
            movementVector.set(0, adjustedStep, 0);
            break;
        case 'down':
            movementVector.set(0, -adjustedStep, 0);
            break;
    }

    return movementVector;
};
